import { connect } from 'react-redux';
import { getLocationMarkers } from '../../../redux/actions/Locations';

const mapStateToProps = state => ({
  area: state.mainreducer.area,
  arealist: state.mainreducer.arealist,
  kind: state.mainreducer.kind,
});

const mapDispatchToProps = dispatch => ({
  onComponentDidMount(areaId, kind) {
    dispatch(getLocationMarkers(areaId, kind));
  },
});

export default ListViewLeftPart => connect(mapStateToProps, mapDispatchToProps)(ListViewLeftPart);
